angular
   .module('vppApp')
   .factory('IdMePopUp', IdMePopUp);

  IdMePopUp.$inject = ['$window', '$rootScope'];

  function IdMePopUp($window, $rootScope) {

		return function(){
		  var idmeEnvCode;
		  var scopeMapping = {
			  frd: 'reverify,responder,nurse,medical,hospital_employee',
			  mpp: 'reverify,military',
			  gmed: 'reverify,teacher'
		  }
		  var idmeRedirectVar = scopeMapping[domainAbbr] || '';	//default to empty string if needed

		  if(['local', 'D1', 'D2', 'D3'].indexOf(environment) >= 0){
				idmeEnvCode = 'f549159222e785c0b986be14e383331d';
			} else {
				idmeEnvCode = '235cc55f0d7092cc2a9017808fa93f95';
			}

		  var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
		  var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

		  var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
		  var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

		  var left = ((width / 2) - (750 / 2)) + dualScreenLeft;
		  var top = ((height / 2) - (780 / 2)) + dualScreenTop;

			window.open("https://groups.id.me/?client_id="+ idmeEnvCode +"&redirect_uri="+ APIPath +"/idme&state="+ APIPath +"&response_type=code&scopes="+ idmeRedirectVar +"&display=popup&callback=callbackFunction", "idme", "scrollbars=yes,menubar=no,status=no,location=no,toolbar=no,width=750,height=780,top=" + top + ",left=" + left);
		};
  }
